import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class MovuRobotics_ds_get_movetask_by_taskidService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { taskId: number }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ActualTargetLocationId?: number, ExpectedTargetLicensePlateId?: number, ExpectedTargetLocationId?: number, OperationCodeId?: number, Priority?: number, ProjectId?: number, ReasonCodeId?: number, WarehouseId?: number, ExpectedTargetLocation?: { Id?: number, Name?: string, WarehouseId?: number }, ActualSourceLicensePlate?: { Id?: number, LookupCode?: string, LicensePlateContents?: { LotId?: number, Lot?: { MaterialId?: number, Material?: { ProjectId?: number, Project?: { LookupCode?: string } } } }[] }, Warehouse?: { Name?: string }, ActualSourceLocation?: { Id?: number, Name?: string, WarehouseId?: number }, ActualTargetLocation?: { Id?: number, Name?: string } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.taskId)) {
      $missingRequiredInParams.push('\'taskId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      taskId: number    }) {
        if(isNil($inParams.taskId)) {
          return true; 
        }
      return false;
    }
}
